export interface SimilarEmailIdentity {
  sender_email?: string | null
  email_subject?: string | null
}

function normalizeUnicode(value: string): string {
  return value.normalize('NFKC');
}

export function normalizeSimilarEmailSender(sender: string | null | undefined): string {
  return sender ? normalizeUnicode(sender).trim().toLowerCase() : '';
}

export function normalizeSimilarEmailSubject(subject: string | null | undefined): string {
  return subject
    ? normalizeUnicode(subject).trim().replace(/\s+/g, ' ').toLowerCase()
    : '';
}

export function getSimilarEmailMatchKey(identity: SimilarEmailIdentity): string | null {
  const sender = normalizeSimilarEmailSender(identity.sender_email);
  const subject = normalizeSimilarEmailSubject(identity.email_subject);
  return sender && subject ? `${sender}\u0000${subject}` : null;
}
